export enum IframeCssClass {
    AttendanceNotes = 'assets/stylesheets/AttendanceNote.css',
    News = 'assets/stylesheets/NewsPost.css'
}

// Keep up-to-date with Website/Widget/v4/startup.js on the backend
export enum IFrameMessageType {
    Ready = "Ready",
    UserAction = "UserAction",
    Scroll = "Scroll",
    Refresh = "Refresh"
}

// Keep up-to-date with Website/Widget/v4/startup.js on the backend
export enum IFrameUserActionType {
    Initiate = "Initiate",
    Submit = "Submit"
}

export abstract class IFrameMessage {
    abstract Type: IFrameMessageType;
}

export class IFrameReadyMessage extends IFrameMessage {
    readonly Type = IFrameMessageType.Ready;
    TrackingCode!: string | null;

    constructor(initializer: Omit<IFrameReadyMessage, 'Type'>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }
}

export class IFrameScrollMessage extends IFrameMessage {
    readonly Type = IFrameMessageType.Scroll;
    OffsetTop!: number;
    OffsetBottom!: number;

    constructor(initializer: Omit<IFrameScrollMessage, 'Type'>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }
}

export class IFrameRefreshMessage extends IFrameMessage {
    readonly Type = IFrameMessageType.Refresh;
}

export abstract class IFrameUserActionMessage extends IFrameMessage {
    readonly Type = IFrameMessageType.UserAction;
    abstract ActionType: IFrameUserActionType;

    FormTitle!: string;
    FormType!: string;

    constructor(initializer: Omit<IFrameUserActionMessage, 'ActionType' | 'Type'>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }
}

export class IFrameUserActionInitiateMessage extends IFrameUserActionMessage {
    readonly ActionType = IFrameUserActionType.Initiate;
}

export class IFrameUserActionSubmitMessage extends IFrameUserActionMessage {
    readonly ActionType = IFrameUserActionType.Submit;
}

export function EncodeHTML(html: string): string {
    const div = document.createElement('div');
    div.textContent = html;
    return div.innerHTML;
}

export function DecodeHTML(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent ?? '';
}